import { useSearchParams } from "react-router-dom";
import { PROFILES } from "../data/quiz";
import { useSiteConfig } from "../hooks/useSiteConfig";

function PageShell({ title, children }) {
  return (
    <div className="flex min-h-screen flex-col bg-base text-ink">
      <main className="mx-auto w-full max-w-[520px] flex-1 px-6 pt-20 pb-16">
        <h1 className="font-display text-3xl font-bold leading-tight sm:text-4xl">{title}</h1>
        <div className="mt-6 space-y-4 text-[15px] leading-relaxed text-soft">{children}</div>
        <a
          href="/"
          className="mt-10 inline-flex min-h-[52px] items-center rounded-full bg-teal px-8 font-display text-[14px] font-bold uppercase tracking-wide text-base transition-colors duration-200 hover:bg-teal-dark"
        >
          Înapoi la quiz
        </a>
      </main>
    </div>
  );
}

const NIVELURI = ["REDUSĂ", "MODERATĂ", "RIDICATĂ"];

export function ConfirmatPage() {
  const [params] = useSearchParams();
  const profile = PROFILES.find((p) => p.key === params.get("profil"));
  const nivel = params.get("nivel");
  const nivelValid = NIVELURI.includes(nivel);

  return (
    <PageShell title="Mulțumim!">
      <p data-testid="confirmat-text">Ți-am trimis ghidul pe email. Verifică și Spam/Promoții.</p>
      {(profile || nivelValid) && (
        <div data-testid="confirmat-profile" className="rounded-2xl border border-teal/25 bg-surface p-5">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-soft">
            Rezumatul tău din quiz
          </p>
          {profile && (
            <p data-testid="confirmat-profile-name" className="mt-2 font-display text-lg font-bold text-teal">
              {profile.name}
            </p>
          )}
          {nivelValid && (
            <p className="text-sm text-soft">
              Utilizare neintenționată: <span className="font-medium text-ink">{nivel}</span>
            </p>
          )}
        </div>
      )}
    </PageShell>
  );
}

export function DezabonatPage() {
  return (
    <PageShell title="Te-ai dezabonat">
      <p data-testid="dezabonat-text">Nu îți mai trimitem emailuri. Acordul tău a fost retras.</p>
    </PageShell>
  );
}

export function ConfidentialitatePage() {
  const { operator_name, operator_email, data_retention_period } = useSiteConfig();

  return (
    <PageShell title="Politica de confidențialitate">
      <p>
        Operator: {operator_name}. Contact: {operator_email}.
      </p>
      <p>
        <strong className="text-ink">Ce date colectăm:</strong> adresa ta de email, profilul și
        intensitatea rezultată din quiz, intervalul de timp raportat și data lațând acordul. Nu
        colectăm răspunsurile individuale din quiz și nu folosim cookie-uri sau instrumente de
        urmărire.
      </p>
      <p>
        <strong className="text-ink">Scopul:</strong> trimiterea ghidului gratuit și a materialelor
        educaționale pe email.
      </p>
      <p>
        <strong className="text-ink">Baza legală:</strong> consimțământul tău, exprimat prin bifarea
        căsuței de acord. Îl poți retrage oricând, prin linkul de dezabonare din fiecare email.
      </p>
      <p>
        <strong className="text-ink">Destinatari:</strong> furnizorul de servicii de email, care
        procesează adresa de email în calitate de persoană împuternicită de operator.
      </p>
      <p>
        <strong className="text-ink">Păstrarea datelor:</strong> {data_retention_period}.
      </p>
      <p>
        <strong className="text-ink">Drepturile tale:</strong> acces, rectificare, ștergere,
        restricționare, portabilitate, opoziție și depunerea unei plângeri la ANSPDCP.
      </p>
    </PageShell>
  );
}

export function TermeniPage() {
  const { operator_name, operator_email } = useSiteConfig();

  return (
    <PageShell title="Termeni de utilizare">
      <p>
        Quiz-ul MindRegen este un instrument educațional de auto-observare. Rezultatele au caracter
        informativ și nu constituie consultanță medicală, psihologică sau de altă natură.
      </p>
      <p>
        Serviciul este oferit ca atare, fără garanții privind rezultatele obținute prin aplicarea
        recomandărilor.
      </p>
      <p>
        Datele personale sunt tratate conform{" "}
        <a href="/confidentialitate" className="text-teal underline underline-offset-4">
          Politicii de confidențialitate
        </a>
        .
      </p>
      <p>
        Operator: {operator_name}. Contact: {operator_email}.
      </p>
    </PageShell>
  );
}

export function ContactPage() {
  const { operator_name, operator_email } = useSiteConfig();

  return (
    <PageShell title="Contact">
      <p>
        Pentru întrebări despre quiz, despre datele tale sau despre dezabonare, scrie-ne la{" "}
        <strong className="text-ink">{operator_email}</strong>.
      </p>
      <p>Operator: {operator_name}.</p>
    </PageShell>
  );
}
